export const columns = [
  {
    title: 'Id',
    name: 'id'
  },
  {
    title: 'Nombre',
    name: 'name'
  },
  {
    title: 'Código',
    name: 'code'
  },
  {
    title: 'Valor',
    name: 'value'
  },
  {
    title: 'Etiquetas',
    name: 'tags'
  }
];

export const mapData = data =>
  data.map(datum => {
    return {
      id: datum.id,
      name: datum.name || '--',
      description: datum.description || '--',
      value: datum.value,
      tags: datum.tags,
      code: datum.code,
      settingType: datum.settingType,
    };
  });

  export const globalSettingTypes = [
    { id: 1, label: 'String', value: 1 },
    { id: 2, label: 'Integer', value: 2 },
    { id: 3, label: 'Float', value: 3 },
    { id: 4, label: 'Boolean', value: 4 },
    { id: 5, label: 'Array', value: 5 },
    { id: 6, label: 'Json', value: 6 },
    { id: 7, label: 'DateTime', value: 7 },
  ]
